// Copyright 2022 Amazon.com, Inc. or its affiliates. All Rights Reserved.
export enum AuthStatus {
  SIGNED_IN = "SIGNED_IN",
  SIGNED_OUT = "SIGNED_OUT",
  LOADING = "LOADING",
  SIGNING_OUT = "SIGNING_OUT",
}
